import { M } from "styled-icons/fa-solid";
import { Arrow, ArrowUp } from "../../assets/images";
const productsEscritorio = [
  {
    id: 0,
    name: "Subir",
    environmentArea: 0,
    category: { image: ArrowUp },
    pinPos: [310.16465383582454, 223.6973661058909, -0.3737567313290532],
    boardPos: [0, 0, 0],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 377.2564965894427,
        y: 853.9503735670879,
        z: -1525.1264231712566,
      },
      target: {
        x: 377.0916363906531,
        y: 853.8582495651767,
        z: -1524.1444179354626,
      },
      posMobile: {
        x: 377.2564965894427,
        y: 853.9503735670879,
        z: -1525.1264231712566,
      },
      targetMobile: {
        x: 377.0916363906531,
        y: 853.8582495651767,
        z: -1524.1444179354626,
      },
    },
    cameraOut: {
      pos: {
        x: 377.3650062380195,
        y: 853.7971925623917,
        z: -1525.006721486755,
      },
      target: {
        x: 377.07481001641054,
        y: 853.8236423349296,
        z: -1524.0501199173978,
      },
    },
  },
  {
    id: -1,
    name: "Descer",
    environmentArea: 0,
    category: { image: Arrow },
    pinPos: [438.160685326184, 832.6774541946927, -1287.7609817284706],
    boardPos: [0, 0, 0],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 73.65370867037373,
        y: 230.7714702122137,
        z: 174.93367314212009,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
      posMobile: {
        x: 73.65370867037373,
        y: 230.7714702122137,
        z: 174.93367314212009,
      },
      targetMobile: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
    cameraOut: {
      pos: {
        x: 73.65474411701116,
        y: 230.7674823081372,
        z: 174.93443776251286,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 38,
    environmentArea: 0,
    pinPos: [126.24447779380662, 361.0883449661808, -2034.6016644156437],
    scale: 2,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 339.6156471582944,
        y: 509.62623978539824,
        z: -1455.1917778925676,
      },
      target: {
        x: 339.1368881963592,
        y: 509.38137974757745,
        z: -1456.0348872675868,
      },
      posMobile: {
        x: 339.6156471582944,
        y: 509.62623978539824,
        z: -1455.1917778925676,
      },
      targetMobile: {
        x: 339.1368881963592,
        y: 509.38137974757745,
        z: -1456.0348872675868,
      },
    },
    cameraOut: {
      pos: {
        x: 73.65474411701116,
        y: 230.7674823081372,
        z: 174.93443776251286,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 39,
    pinPos: [294.92310368423693, 821.0053018542607, -1612.5448995212057],
    scale: 0.5,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 350.4943562364239,
        y: 814.5511721500227,
        z: -1426.5999456152476,
      },
      target: {
        x: 350.0728355746797,
        y: 814.5693650574602,
        z: -1427.5065818983521,
      },
      posMobile: {
        x: 350.4943562364239,
        y: 814.5511721500227,
        z: -1426.5999456152476,
      },
      targetMobile: {
        x: 350.0728355746797,
        y: 814.5693650574602,
        z: -1427.5065818983521,
      },
    },
    cameraOut: {
      pos: {
        x: 377.74884835468714,
        y: 853.7008843453565,
        z: -1523.2425741008879,
      },
      target: {
        x: 377.05592717303307,
        y: 853.8201639366027,
        z: -1523.9536525882063,
      },
    },
  },
  {
    id: 40,
    pinPos: [533.0324384532462, 448.5543237753312, -276.0690933996871],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 282.4500545588796,
        y: 226.08119621404728,
        z: -43.051834749947666,
      },
      target: {
        x: 282.9588153980088,
        y: 226.62145068296635,
        z: -43.7221238796383,
      },
      posMobile: {
        x: 282.4500545588796,
        y: 226.08119621404728,
        z: -43.051834749947666,
      },
      targetMobile: {
        x: 282.9588153980088,
        y: 226.62145068296635,
        z: -43.7221238796383,
      },
    },
    cameraOut: {
      pos: {
        x: 73.65474411701116,
        y: 230.7674823081372,
        z: 174.93443776251286,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 41,
    pinPos: [80.37882801500439, 37.15357681956043, -340.4449247944001],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 204.63088521341828,
        y: 213.2334898335511,
        z: -12.572127198181978,
      },
      target: {
        x: 204.18238584387055,
        y: 212.7630593256901,
        z: -13.332089995158876,
      },
      posMobile: {
        x: 204.63088521341828,
        y: 213.2334898335511,
        z: -12.572127198181978,
      },
      targetMobile: {
        x: 204.18238584387055,
        y: 212.7630593256901,
        z: -13.332089995158876,
      },
    },
    cameraOut: {
      pos: {
        x: 73.65474411701116,
        y: 230.7674823081372,
        z: 174.93443776251286,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 42,
    environmentArea: 0,
    pinPos: [550.4046930297889, 1166.62615263063, -860.818630178901],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 489.88745378666164,
        y: 933.7087137196849,
        z: -1186.0860176119975,
      },
      target: {
        x: 490.1925817913227,
        y: 934.2733356315209,
        z: -1185.3191414828566,
      },
      posMobile: {
        x: 489.88745378666164,
        y: 933.7087137196849,
        z: -1186.0860176119975,
      },
      targetMobile: {
        x: 490.1925817913227,
        y: 934.2733356315209,
        z: -1185.3191414828566,
      },
    },
    cameraOut: {
      pos: {
        x: 377.3650062380195,
        y: 853.7971925623917,
        z: -1525.006721486755,
      },
      target: {
        x: 377.07481001641054,
        y: 853.8236423349296,
        z: -1524.0501199173978,
      },
    },
  },
  {
    id: 43,
    environmentArea: 0,
    pinPos: [86.96740625637531, 547.1343543975547, -695.6124639229215],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 149.17688663966604,
        y: 494.7950087213944,
        z: -1005.2541407247767,
      },
      target: {
        x: 149.13744187486157,
        y: 494.9434378182047,
        z: -1004.2660046441938,
      },
      posMobile: {
        x: 149.17688663966604,
        y: 494.7950087213944,
        z: -1005.2541407247767,
      },
      targetMobile: {
        x: 149.13744187486157,
        y: 494.9434378182047,
        z: -1004.2660046441938,
      },
    },
    cameraOut: {
      pos: {
        x: 73.65474411701116,
        y: 230.7674823081372,
        z: 174.93443776251286,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 44,
    pinPos: [156.9096395064464, 811.2870068947766, -1615.1099676981985],
    scale: 0.8,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 118.00872956065726,
        y: 799.948041988914,
        z: -1380.8694952213098,
      },
      target: {
        x: 118.0017718966524,
        y: 799.9166027996962,
        z: -1381.868976671009,
      },
      posMobile: {
        x: 118.00872956065726,
        y: 799.948041988914,
        z: -1380.8694952213098,
      },
      targetMobile: {
        x: 118.0017718966524,
        y: 799.9166027996962,
        z: -1381.868976671009,
      },
    },
    cameraOut: {
      pos: {
        x: 377.74884835468714,
        y: 853.7008843453565,
        z: -1523.2425741008879,
      },
      target: {
        x: 377.05592717303307,
        y: 853.8201639366027,
        z: -1523.9536525882063,
      },
    },
  },
  {
    id: 45,
    name: "Nexalux Vert 90/65 Sonex",
    pinPos: [38.683200152391805, 1166.209735014938, -1910.2680680754693],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 476.6529670443307,
        y: 912.258068380622,
        z: -2019.1229033423617,
      },
      target: {
        x: 475.848512500623,
        y: 912.7271922235805,
        z: -2018.7585193319057,
      },
      posMobile: {
        x: 476.6529670443307,
        y: 912.258068380622,
        z: -2019.1229033423617,
      },
      targetMobile: {
        x: 475.848512500623,
        y: 912.7271922235805,
        z: -2018.7585193319057,
      },
    },
    cameraOut: {
      pos: {
        x: 377.74884835468714,
        y: 853.7008843453565,
        z: -1523.2425741008879,
      },
      target: {
        x: 377.05592717303307,
        y: 853.8201639366027,
        z: -1523.9536525882063,
      },
    },
  },
  {
    id: 46,
    environmentArea: 0,
    pinPos: [549.0789954727826, 299.7549481858215, -54.265382401004445],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 438.0008324862687,
        y: 373.00274734426233,
        z: -208.56861143868684,
      },
      target: {
        x: 438.66534342278464,
        y: 372.59757897976027,
        z: -207.940707137334,
      },
      posMobile: {
        x: 438.0008324862687,
        y: 373.00274734426233,
        z: -208.56861143868684,
      },
      targetMobile: {
        x: 438.66534342278464,
        y: 372.59757897976027,
        z: -207.940707137334,
      },
    },
    cameraOut: {
      pos: {
        x: 73.65474411701116,
        y: 230.7674823081372,
        z: 174.93443776251286,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 63,
    environmentArea: 0,
    pinPos: [-156.07134719437494, 839.6949138328248, -765.9375943890342],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 281.77570568174593,
        y: 836.1431596834021,
        z: -1034.0003401885233,
      },
      target: {
        x: 281.02214462727244,
        y: 836.1298777294443,
        z: -1033.3430964537645,
      },
      posMobile: {
        x: 281.77570568174593,
        y: 836.1431596834021,
        z: -1034.0003401885233,
      },
      targetMobile: {
        x: 281.02214462727244,
        y: 836.1298777294443,
        z: -1033.3430964537645,
      },
    },
    cameraOut: {
      pos: {
        x: 377.3650062380195,
        y: 853.7971925623917,
        z: -1525.006721486755,
      },
      target: {
        x: 377.07481001641054,
        y: 853.8236423349296,
        z: -1524.0501199173978,
      },
    },
  },
];

export default productsEscritorio;
